(() => {
  const initCrossSell = () => {
    document.querySelectorAll('[data-so-cross-add]').forEach((button) => {
      if (button.dataset.soBound === 'true') return;
      button.dataset.soBound = 'true';

      button.addEventListener('click', async () => {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = '…';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number.parseInt(variantId, 10), quantity: 1 }),
          });

          if (!response.ok) throw new Error('add failed');

          button.textContent = 'Ajouté';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

          window.setTimeout(() => {
            button.textContent = originalLabel;
            button.disabled = false;
          }, 1800);
        } catch {
          button.textContent = 'Erreur';
          window.setTimeout(() => {
            button.textContent = originalLabel;
            button.disabled = false;
          }, 1800);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrossSell);
  } else {
    initCrossSell();
  }
})();
